
'use strict';

export default class Dictionary {

    static getPlatformAppList() {
        let apps = [
            {
                code: 'PushService',
                name: '推送服务',
                description: '推送服务',
                url: ''
            },
            {
                code: 'DeviceService',
                name: '设备服务',
                description: '设备服务',
                url: 'https://ddb.btlsz.com/device'
            }
        ];


        return apps;
    }

    static getPlatformApp(code = null) {
        const arr = Dictionary.getPlatformAppList();
        var app = null;
        for (let a of arr) {
            if (a.code === code) {
                app = a;
                break;
            }
        }
        return app;
    }

    static getPageNumList() {
        return [20, 50, 100];
    }
 
};



// WEBPACK FOOTER //
// ./src/config/dictionary.js